<template>
  <div class="main">
    <b-collapse
      class="card"
      animation="slide"
      :open="isOpen == 1"
      @open="isOpen = 1"
    >
      <div slot="trigger" slot-scope="props" class="card-header" role="button">
        <p class="card-header-title">
          Réseaux
        </p>
        <a class="card-header-icon">
          <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"> </b-icon>
        </a>
      </div>
      <div class="card-content">
        <h3 class="has-text-warning">
          ⚠️ En cas de bug veuillez le report sur le channel imposteur du
          discord
        </h3>
        <div class="networks">
          <div
            v-for="(network, idx) in networks"
            :key="idx"
            @click="toUrl(network.url)"
            class="network"
          >
            <b-icon size="is-medium" :icon="network.icon" />
            <p>{{ network.name }}</p>
          </div>
        </div>
      </div>
    </b-collapse>
    <b-collapse
      class="card"
      animation="slide"
      :open="isOpen == 0"
      @open="isOpen = 0"
    >
      <div slot="trigger" slot-scope="props" class="card-header" role="button">
        <p class="card-header-title">
          Règles
        </p>
        <a class="card-header-icon">
          <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"> </b-icon>
        </a>
      </div>
      <div class="card-content">
        <div class="content">
          Tout le monde possède le même mot sauf une personne: c'est
          l'imposteur. L'imposteur lui même ne sait pas si il est l'imposteur,
          chacun à votre tour écrivez un mot pour prouver que vous n'êtes pas
          l'imposteur. L'imposteur gagne si il n'est pas le plus voté à la fin,
          sinon les autres joueurs gagnent.
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: 1,
      networks: [
        {
          icon: "discord",
          name: "Discord Kgames",
          url: "https://discord.gg/Ejuucj6"
        },
        {
          icon: "twitch",
          name: "Twitch Kameto",
          url: "https://twitch.tv/kamet0"
        },
        {
          icon: "youtube",
          name: "Youtube Kameto",
          url: "https://www.youtube.com/user/KoteiLoL"
        },
        {
          icon: "twitter",
          name: "Twitter Kameto Corp.",
          url: "https://twitter.com/KametoCorp"
        }
      ]
    };
  },
  methods: {
    toUrl(url) {
      window.location.replace(url);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/palette.scss";

.network {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.networks {
  display: flex;
  height: 90%;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.card {
  background-color: $intru-2-hex;
  border-radius: 5px;
  color: white;
}

.card-content {
  background-color: $intru-3-hex;
  border-radius: 5px;
  height: calc(500px - 96px);
  width: 400px;
  text-align: justify;
  @media only screen and (max-width: 800px) {
    width: auto;
  }
}

.card-header-title {
  color: white;
}
</style>
